// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BxbQj","disabled":"styles_disabled__1XLc2"};